import React from 'react';
import { Link } from 'react-router-dom';
import PublicNoticePage from './common/PublicNoticePage';

const NotFoundPage: React.FC = () => {
  return (
    <PublicNoticePage
      logoTo='/'
      title="I can do nearly anything, but I can't find that"
      body='The page you were after may have moved, or the link is out of date.'
      actions={
        <Link to='/' className='public-notice__button'>
          Back to home
        </Link>
      }
    />
  );
};

export default NotFoundPage;
